import { useEffect, useState } from "react";
import {
  fetchServiceDashboardBootstrap,
  ServiceDashboardBootstrapResponse,
  ServiceIndividualFilterParams,
} from "../services/serviceIndividualDashboardApi";

interface ServiceDashboardBootstrapState {
  data: ServiceDashboardBootstrapResponse | null;
  isLoading: boolean;
  error: string | null;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return "Failed to load Service dashboard.";
};

export const useServiceDashboardBootstrap = (
  filters: ServiceIndividualFilterParams,
  enabled: boolean,
  view = "individual",
  comparisonPeriod?: string,
  refreshKey = 0,
): ServiceDashboardBootstrapState => {
  const [state, setState] = useState<ServiceDashboardBootstrapState>({
    data: null,
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;
    if (filters.period === "custom" && (!filters.from_date || !filters.to_date)) return;

    let isCurrent = true;
    setState((current) => ({ ...current, isLoading: true, error: null }));

    fetchServiceDashboardBootstrap(filters, view, comparisonPeriod)
      .then((data) => {
        if (!isCurrent) return;
        setState({ data, isLoading: false, error: null });
      })
      .catch((error) => {
        if (!isCurrent) return;
        setState((current) => ({
          ...current,
          isLoading: false,
          error: getErrorMessage(error),
        }));
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, filters.period, filters.from_date, filters.to_date, view, comparisonPeriod, refreshKey]);

  return state;
};
